import { useEffect, useRef } from "react";

const RemoteMonitor = (props: { children: any; }) => {
  const trackerRef = useRef<any>(null);

  useEffect(() => {
    // Only load the tracker library if monitoring is enabled
    if (localStorage.getItem('monitoringOn') === 'true') {
      // Dynamic import - only loads @openreplay/tracker when needed
      import('@openreplay/tracker').then(({ default: Tracker }) => {
        trackerRef.current = new Tracker({
          projectKey: "KYbd6KJH3xj53FOoo7Xx",
          __DISABLE_SECURE_MODE: process.env.NODE_ENV === 'production' ? false : true,
        });
        trackerRef.current.start();
      }).catch((error) => {
        console.error('Failed to load OpenReplay tracker:', error);
      });
    }

    return () => {
      if (trackerRef.current) {
        trackerRef.current.stop();
      }
    };
  }, []);

  return props.children;
};

export default RemoteMonitor;